import CatDate from "./CatDate";
import CurrentProblem from "./CurrentProblem";
import {modifyDate} from '../../../../../functions/Functions';

function DashboardProblemContent(props) {
    const {problems, limit, showMore, problem_index} = props
    if(problems.results) {
        const {results} = problems;
        if(results[problem_index]) {
            return (
                <div id="dashboard-problem-content" className="animated">
                    <CatDate 
                        problem_text={results[problem_index].problem}
                        current_category={results[problem_index].category?results[problem_index].category.name: ''}
                        current_date={modifyDate(results[problem_index].sent_at)}  
                    />
                    <CurrentProblem
                        problem_text={results[problem_index].problem}
                        limit={limit}
                        showMore={showMore} 
                    />
                </div>
            )
        }
    }
}

export default DashboardProblemContent;